import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { PERMISSIONS_FEATURE, permissionsReducer } from './permissions.reducer';
import { PermissionsService } from './permissions.service';
import { AngularSharedModule } from '../../shared/angularShared/angularShared.module';

@NgModule({
  imports: [
    AngularSharedModule,
    StoreModule.forFeature(PERMISSIONS_FEATURE, permissionsReducer),
  ],
  providers: [
    PermissionsService
  ],
  exports: [
    AngularSharedModule
  ]
})
export class PermissionsModule { }
